import { useTranslation } from 'react-i18next';

import { describeWorkflow } from './workflow-sentence';
import type { Names, WorkflowDefinition } from './workflows-api';

/**
 * תצוגת כרטיס propose_workflow בעוזר: הכלל במילים, ואמירה ברורה שהוא נוצר
 * *פעיל* באישור (וניתן לכיבוי ב"התהליכים שלי"). השמות מגיעים מהשרת (preview.names).
 */
export function WorkflowCardPreview({ preview }: { preview: Record<string, unknown> }) {
  const { t } = useTranslation(['workflows', 'assistant']);
  const def = preview['definition'] as WorkflowDefinition | undefined;
  const raw = (preview['names'] ?? {}) as Partial<Names>;
  if (!def?.trigger || !Array.isArray(def.actions)) return null;
  const names: Names = {
    jobTypes: raw.jobTypes ?? {},
    users: raw.users ?? {},
    suppliers: raw.suppliers ?? {},
  };
  return (
    <div className="space-y-1">
      <p className="font-medium text-fg">{def.name}</p>
      <p className="text-fg">
        {describeWorkflow(t, { ...def, conditions: def.conditions ?? [] }, names)}
      </p>
      <p className="text-xs text-fg-muted">{t('assistant:card.workflowEnabled')}</p>
    </div>
  );
}
